// reducers/employee-onboarding/approve.js

// approve

export function approveHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_APPROVE_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function approveIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_APPROVE_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function approve(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_APPROVE_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}

// approveCheck

export function approveCheckHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_APPROVE_CHECK_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function approveCheckIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_APPROVE_CHECK_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function approveCheck(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_APPROVE_CHECK_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}